module.exports = __webpack_public_path__ + "img/UN_Women_Spurning01.830edee7.gif";